const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const formatMessage = require('format-message');
const Cast = require('../../util/cast');
const menuIconURI = "data:image/png;base64,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";


class Variable {
    constructor(runtime) {
        this.runtime = runtime;
        this.functions = {};
        // Initialize an object to store all variables
        this._variables = new Map();
    }

    getInfo() {
        return {
            id: 'variable',
            color1: '#5527ff',
            name: formatMessage({
                id: 'variable.categoryName',
                default: 'Python Variable',
                description: 'python variable extension'
            }),
            menuIconURI: menuIconURI,
            blockIconURI: menuIconURI,
            blocks: [
                {
                    opcode: "python_set_variable",
                    blockType: BlockType.COMMAND,
                    text: "[VAR_NAME] = [VALUE]",
                    arguments: {
                        VAR_NAME: {
                            type: ArgumentType.STRING,
                            defaultValue: "myVar"
                        },
                        VALUE: {
                            type: ArgumentType.STRING,
                            defaultValue: '"example"'
                        }
                    }
                },
                {
                    opcode: "python_get_all_variables",
                    blockType: BlockType.REPORTER,
                    text: "get all variables"
                },
                {
                    opcode: "python_get_variable_value",
                    blockType: BlockType.REPORTER,
                    text: "[VAR_NAME]",
                    arguments: {
                        VAR_NAME: {
                            type: ArgumentType.STRING,
                            defaultValue: "myVar"
                        }
                    }
                },
                ,
                {
                    opcode: "python_update_variable",
                    blockType: BlockType.COMMAND,
                    text: "[VAR_NAME] [OPERATION] [AMOUNT]",
                    arguments: {
                        VAR_NAME: {
                            type: ArgumentType.STRING,
                            defaultValue: 'myVar'
                        },
                        OPERATION: {
                            type: ArgumentType.STRING,
                            menu: 'operationMenu',
                            defaultValue: '+='
                        },
                        AMOUNT: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 1
                        }
                    }
                },
                {
                    opcode: "python_delete_variable",
                    blockType: BlockType.COMMAND,
                    text: "delete_var ( [VAR_NAME] )",
                    arguments: {
                        VAR_NAME: {
                            type: ArgumentType.STRING,
                            defaultValue: "myVar"
                        }
                    }
                },
                {
                    opcode: "python_clear_all_variables",
                    blockType: BlockType.COMMAND,
                    text: "clear_all_var ( )"
                },
                {
                    opcode: "python_make_list",
                    blockType: BlockType.COMMAND,
                    text: "[LIST_NAME] = [ITEMS]",
                    arguments: {
                        LIST_NAME: {
                            type: ArgumentType.STRING,
                            defaultValue: "myList"
                        },
                        ITEMS: {
                            type: ArgumentType.STRING,
                            defaultValue: "[1, 2, 3]"
                        }
                    }
                },
                {
                    opcode: "python_get_list",
                    blockType: BlockType.REPORTER,
                    text: "[LIST_NAME]",
                    arguments: {
                        LIST_NAME: {
                            type: ArgumentType.STRING,
                            defaultValue: "myList"
                        }
                    }
                },
                {
                    opcode: "python_show_all_lists",
                    blockType: BlockType.REPORTER,
                    text: "show all lists"
                },
                {
                    opcode: "python_append_list",
                    blockType: BlockType.COMMAND,
                    text: "[LIST_NAME].append([ITEM])",
                    arguments: {
                        LIST_NAME: {
                            type: ArgumentType.STRING,
                            defaultValue: "myList"
                        },
                        ITEM: {
                            type: ArgumentType.STRING,
                            defaultValue: "item"
                        }
                    }
                },
                {
                    opcode: "python_get_list_item",
                    blockType: BlockType.REPORTER,
                    text: "[LIST_NAME][INDEX]",
                    arguments: {
                        LIST_NAME: {
                            type: ArgumentType.STRING,
                            defaultValue: "myList"
                        },
                        INDEX: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0
                        }
                    }
                },
                {
                    opcode: "python_reverse_list",
                    blockType: BlockType.COMMAND,
                    text: "[LIST_NAME]. reverse ( )",
                    arguments: {
                        LIST_NAME: {
                            type: ArgumentType.STRING,
                            defaultValue: "myList"
                        }
                    }
                },
                {
                    opcode: "python_find_index",
                    blockType: BlockType.REPORTER,
                    text: "[LIST_NAME]. index([ITEM]) ",
                    arguments: {
                        ITEM: {
                            type: ArgumentType.STRING,
                            defaultValue: "item"
                        },
                        LIST_NAME: {
                            type: ArgumentType.STRING,
                            defaultValue: "myList"
                        }
                    }
                },
            ],
            menus: {
                operationMenu: ['+=', '-=', '*=', '/=']
            }
        };
    }

    python_set_variable(args, util) {
        const varName = Cast.toString(args.VAR_NAME);
        let value = args.VALUE;

        if (typeof value === 'string') {
            if ((value.startsWith('"') && value.endsWith('"')) ||
                (value.startsWith("'") && value.endsWith("'"))) {

                }else {
                try {
                    // Try parsing as number or boolean
                    if (value.toLowerCase() === 'true') value = true;
                    else if (value.toLowerCase() === 'false') value = false;
                    else if (!isNaN(value)) value = Number(value);
                    else value = JSON.parse(value);
                } catch (e) {
                    value = `"${Cast.toString(value)}"`;
                }
            }
        }

        if (!util.target.variables[varName]) {
            // Create a new variable if it doesn't exist
            util.target.createVariable(varName, value, '');
            util.target.variables[varName].value = value;
        } else {
            // Update existing variable
            util.target.variables[varName].value = value;
        }

        console.log(`Variable "${varName}" set to:`, value);
    }

    python_get_all_variables(args, util) {
        const variables = util.target.variables || {};
        const result = Object.entries(variables)
            .map(([name, variable]) => {
                const value = typeof variable.value === 'string' ?
                    `${variable.value}` : variable.value;
                return `${name} = ${value}`;
            })
            .join('\n');

        return result || "No variables defined";
    }

    python_get_variable_value(args, util) {
        const varName = Cast.toString(args.VAR_NAME);
        const variable = util.target.variables[varName];

        if (!variable) {
            return `Variable "${varName}" not found`;
        }
        return variable.value;
    }

    python_delete_variable(args, util) {
        const varName = Cast.toString(args.VAR_NAME);
        if (util.target.variables[varName]) {
            delete util.target.variables[varName];
            return true;
        }
        return false;
    }

    python_clear_all_variables(args, util) {
        // Get all variable names
        const variables = util.target.variables || {};
        const variableNames = Object.keys(variables);

        // Delete each variable
        variableNames.forEach(varName => {
            delete util.target.variables[varName];
        });

        console.log("All variables cleared");
        return true;
    }

    python_make_list(args, util) {
        const listName = Cast.toString(args.LIST_NAME);
        let items;
        try {
            items = JSON.parse(args.ITEMS.replace(/'/g, '"'));
        } catch (e) {
            items = [];
        }
        util.target.variables[listName] = { value: items };
    }

    python_get_list(args, util) {
        const listName = Cast.toString(args.LIST_NAME);
        const list = util.target.variables[listName]?.value;
        if (Array.isArray(list)) {
            return JSON.stringify(list);
        }
        return '[]';
    }

    python_show_all_lists(args, util) {
        const variables = util.target.variables || {};
        const lists = Object.entries(variables)
            .filter(([_, variable]) => Array.isArray(variable.value))
            .map(([name, variable]) => `${name} = ${JSON.stringify(variable.value)}`)
            .join('\n');
        
        return lists || "No lists found";
    }

    python_append_list(args, util) {
        const listName = Cast.toString(args.LIST_NAME);
        const item = args.ITEM;
        if (util.target.variables[listName]?.value?.push) {
            util.target.variables[listName].value.push(item);
        }
    }

    python_get_list_item(args, util) {
        const listName = Cast.toString(args.LIST_NAME);
        const index = Math.floor(Cast.toNumber(args.INDEX));
        const list = util.target.variables[listName]?.value;
        if (Array.isArray(list) && index >= 0 && index < list.length) {
            return list[index];
        }
        return '';
    }

    python_reverse_list(args, util) {
        const listName = Cast.toString(args.LIST_NAME);
        const list = util.target.variables[listName]?.value;
        if (Array.isArray(list)) {
            util.target.variables[listName].value = list.reverse();
        }
    }

    python_find_index(args, util) {
        const listName = Cast.toString(args.LIST_NAME);
        let searchItem = args.ITEM;
        const list = util.target.variables[listName]?.value;
        
        if (Array.isArray(list)) {
            // Try to convert searchItem to number if it's numeric
            if (!isNaN(searchItem)) {
                searchItem = Number(searchItem);
            }
            
            // Search for exact match first
            let index = list.findIndex(item => item === searchItem);
            
            // If not found, try string comparison
            if (index === -1) {
                index = list.findIndex(item => String(item) === String(searchItem));
            }
            
            return index !== -1 ? index : "Item not found";
        }
        return "List not found";
    }

    python_update_variable(args, util) {
        const varName = Cast.toString(args.VAR_NAME);
        const op = args.OPERATION;
        const amount = Cast.toNumber(args.AMOUNT);
        const variable = util.target.variables[varName];

        if (!variable) return;

        let current = variable.value;
        if (typeof current !== 'number') current = Number(current) || 0;

        switch (op) {
            case '+=': variable.value = current + amount; break;
            case '-=': variable.value = current - amount; break;
            case '*=': variable.value = current * amount; break;
            case '/=': variable.value = amount !== 0 ? current / amount : 0; break;
        }
    }
}

module.exports = Variable;